import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Description',
    field: 'description',
    type: 'text',
    component: inputTextField({ req: true })
  })
].concat(defaultColumns)
